<template>
  <TableLayout :permissions="['business:alibilldetail:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="对账单ID" prop="pid">
        <el-input v-model="searchForm.pid" placeholder="请输入对账单ID" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易时间" prop="billDate">
        <el-date-picker v-model="searchForm.billDate" value-format="yyyy-MM-dd" placeholder="请输入交易时间" @change="search"/>
      </el-form-item>
      <el-form-item label="商户号" prop="mchId">
        <el-input v-model="searchForm.mchId" placeholder="请输入商户号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="微信订单号" prop="transactionId">
        <el-input v-model="searchForm.transactionId" placeholder="请输入微信订单号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="商户订单号" prop="outTradeNo">
        <el-input v-model="searchForm.outTradeNo" placeholder="请输入商户订单号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="用户标识" prop="openid">
        <el-input v-model="searchForm.openid" placeholder="请输入用户标识" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易类型" prop="billType">
        <el-input v-model="searchForm.billType" placeholder="请输入交易类型" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="券核销金额（元）" prop="couponFee">
        <el-input v-model="searchForm.couponFee" placeholder="请输入券核销金额（元）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="退款批次号/请求号" prop="refundId">
        <el-input v-model="searchForm.refundId" placeholder="请输入退款批次号/请求号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="商品名称" prop="body">
        <el-input v-model="searchForm.body" placeholder="请输入商品名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="手续费" prop="cmmsAmt">
        <el-input v-model="searchForm.cmmsAmt" placeholder="请输入手续费" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="订单金额" prop="totalFee">
        <el-input v-model="searchForm.totalFee" placeholder="请输入订单金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="申请退款金额" prop="applyRefundFee">
        <el-input v-model="searchForm.applyRefundFee" placeholder="请输入申请退款金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="商家实收（元）" prop="receipts">
        <el-input v-model="searchForm.receipts" placeholder="请输入商家实收（元）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="支付宝红包（元）" prop="aliRedEnvelope">
        <el-input v-model="searchForm.aliRedEnvelope" placeholder="请输入支付宝红包（元）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="集分宝（元）" prop="jifenbao">
        <el-input v-model="searchForm.jifenbao" placeholder="请输入集分宝（元）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="支付宝优惠（元）" prop="aliOfferFee">
        <el-input v-model="searchForm.aliOfferFee" placeholder="请输入支付宝优惠（元）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="商家优惠（元）" prop="offerFee">
        <el-input v-model="searchForm.offerFee" placeholder="请输入商家优惠（元）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="券名称" prop="couponName">
        <el-input v-model="searchForm.couponName" placeholder="请输入券名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="商家红包消费金额（元）" prop="redEnvelope">
        <el-input v-model="searchForm.redEnvelope" placeholder="请输入商家红包消费金额（元）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="卡消费金额（元）" prop="cardFee">
        <el-input v-model="searchForm.cardFee" placeholder="请输入卡消费金额（元）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="分润" prop="shareProfit">
        <el-input v-model="searchForm.shareProfit" placeholder="请输入分润" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="门店名称" prop="mchName">
        <el-input v-model="searchForm.mchName" placeholder="请输入门店名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="操作员" prop="opName">
        <el-input v-model="searchForm.opName" placeholder="请输入操作员" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="终端号" prop="tty">
        <el-input v-model="searchForm.tty" placeholder="请输入终端号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:alibilldetail:create']">
        <li><el-button type="primary" @click="$refs.operaAliBillDetailWindow.open('新建')" icon="el-icon-plus" v-permissions="['business:alibilldetail:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="id" label="" min-width="100px"></el-table-column>
        <el-table-column prop="pid" label="对账单ID" min-width="100px"></el-table-column>
        <el-table-column prop="billDate" label="交易时间" min-width="100px"></el-table-column>
        <el-table-column prop="mchId" label="商户号" min-width="100px"></el-table-column>
        <el-table-column prop="transactionId" label="微信订单号" min-width="100px"></el-table-column>
        <el-table-column prop="outTradeNo" label="商户订单号" min-width="100px"></el-table-column>
        <el-table-column prop="openid" label="用户标识" min-width="100px"></el-table-column>
        <el-table-column prop="billType" label="交易类型" min-width="100px"></el-table-column>
        <el-table-column prop="couponFee" label="券核销金额（元）" min-width="100px"></el-table-column>
        <el-table-column prop="refundId" label="退款批次号/请求号" min-width="100px"></el-table-column>
        <el-table-column prop="body" label="商品名称" min-width="100px"></el-table-column>
        <el-table-column prop="cmmsAmt" label="手续费" min-width="100px"></el-table-column>
        <el-table-column prop="totalFee" label="订单金额" min-width="100px"></el-table-column>
        <el-table-column prop="applyRefundFee" label="申请退款金额" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="receipts" label="商家实收（元）" min-width="100px"></el-table-column>
        <el-table-column prop="aliRedEnvelope" label="支付宝红包（元）" min-width="100px"></el-table-column>
        <el-table-column prop="jifenbao" label="集分宝（元）" min-width="100px"></el-table-column>
        <el-table-column prop="aliOfferFee" label="支付宝优惠（元）" min-width="100px"></el-table-column>
        <el-table-column prop="offerFee" label="商家优惠（元）" min-width="100px"></el-table-column>
        <el-table-column prop="couponName" label="券名称" min-width="100px"></el-table-column>
        <el-table-column prop="redEnvelope" label="商家红包消费金额（元）" min-width="100px"></el-table-column>
        <el-table-column prop="cardFee" label="卡消费金额（元）" min-width="100px"></el-table-column>
        <el-table-column prop="shareProfit" label="分润" min-width="100px"></el-table-column>
        <el-table-column prop="mchName" label="门店名称" min-width="100px"></el-table-column>
        <el-table-column prop="opName" label="操作员" min-width="100px"></el-table-column>
        <el-table-column prop="tty" label="终端号" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:alibilldetail:update', 'business:alibilldetail:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaAliBillDetailWindow.open('编辑', row)" icon="el-icon-edit" v-permissions="['business:alibilldetail:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:alibilldetail:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaAliBillDetailWindow ref="operaAliBillDetailWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaAliBillDetailWindow from '@/components/business/OperaAliBillDetailWindow'
export default {
  name: 'AliBillDetail',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaAliBillDetailWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        pid: '',
        billDate: '',
        mchId: '',
        transactionId: '',
        outTradeNo: '',
        openid: '',
        billType: '',
        couponFee: '',
        refundId: '',
        body: '',
        cmmsAmt: '',
        totalFee: '',
        applyRefundFee: '',
        remark: '',
        receipts: '',
        aliRedEnvelope: '',
        jifenbao: '',
        aliOfferFee: '',
        offerFee: '',
        couponName: '',
        redEnvelope: '',
        cardFee: '',
        shareProfit: '',
        mchName: '',
        opName: '',
        tty: ''
      }
    }
  },
  created () {
    this.config({
      module: '',
      api: '/business/aliBillDetail',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
